import React, { ReactNode, memo } from 'react';
import { useSelector } from 'react-redux';

import DefaultDrawerFooterButton from 'components/buttons/DefaultDrawerFooterButton';
import DefaultDrawer from 'components/composites/DefaultDrawer';
import { makeSelectIsLoading } from 'store/modules/loading/selectors';

interface Props {
  visible: boolean;
  actions: string[];
  backOfficeSection: string;
  handleSave?: () => void;
  handleClose: () => void;
  noFooter?: boolean;
  footerLabel?: string;
  children: ReactNode;
}

/**
 * Template component for drawers in the Back Office.
 */
function BackOfficeDrawer({
  visible,
  actions,
  backOfficeSection,
  handleSave,
  handleClose,
  noFooter,
  footerLabel = 'Save',
  children
}: Props): JSX.Element {
  const selectIsLoading = makeSelectIsLoading(actions);
  const isLoading = useSelector(selectIsLoading);
  const footer = noFooter ? null : (
    <DefaultDrawerFooterButton
      onClick={handleSave}
      loading={isLoading}
    >
      {footerLabel}
    </DefaultDrawerFooterButton>
  );

  return (
    <DefaultDrawer
      id={backOfficeSection}
      placement="right"
      width={400}
      mask={false}
      disableAnimation
      title={backOfficeSection}
      open={visible}
      onClose={handleClose}
      footer={footer}
    >
      {children}
    </DefaultDrawer>
  );
}

export default memo(BackOfficeDrawer);
